export default __webpack_public_path__ + "static/media/peep-48.505a8e1c.svg";